module.exports = __webpack_public_path__ + "img/727.b1c068b0.png";